import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default function(WrappedComponent) {
  class Container extends Component {
    static displayName = 'PreviewImageHoverItemContainer'

    static propTypes = {
      onClick: PropTypes.func.isRequired,
      position: PropTypes.oneOf(['left', 'right']).isRequired,
    }

    state = {
      mouseOver: false,
    }

    handleMouseEnter = () => {
      this.setState({ mouseOver: true })
    }

    handleMouseLeave = () => {
      this.setState({ mouseOver: false })
    }

    render() {
      const { mouseOver } = this.state

      return (
        <WrappedComponent
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
          mouseOver={mouseOver}
          {...this.props}
        />
      )
    }
  }

  return Container
}
